export const regExpAZ = /[a-zA-Z]/g;